import { StyleSheet, Platform } from 'react-native';
import { SPACING, RADIUS, COLORS, SHADOWS, TYPOGRAPHY } from './src/constants/theme';
import { ButtonStyles } from './src/styles/ButtonStyles';

/**
 * App-specific styles
 * Uses shared ButtonStyles for buttons
 * To change the theme, update the constants in theme.ts
 */
const AppStyles = StyleSheet.create({
    safeArea: {
        flex: 1,
        minHeight: '100%',
        height: '100%',
        backgroundColor: COLORS.gradients.primary.start,
    },
    flex1: {
        flex: 1,
        minHeight: '100%',
    },
    appContainer: {
        flex: 1,
        minHeight: '100%',
        backgroundColor: COLORS.gradients.primary.start,
    },
    authContainer: {
        flex: 1,
        minHeight: '100%',
        width: '100%',
        backgroundColor: COLORS.gradients.primary.start,
    },
    splashContent: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        padding: SPACING.xl,
    },
    splashLogo: {
        marginBottom: SPACING.xl,
    },
    appTitle: {
        fontSize: Platform.select({ ios: 42, android: 38, default: 48 }),
        fontWeight: TYPOGRAPHY.fontWeight.bold,
        color: COLORS.white,
        marginBottom: SPACING.md,
        textShadowColor: 'rgba(0,0,0,0.2)',
        textShadowOffset: { width: 0, height: 4 },
        textShadowRadius: 8,
        includeFontPadding: false,
    },
    appSubtitle: {
        fontSize: TYPOGRAPHY.fontSize.lg,
        color: 'rgba(255,255,255,0.9)',
        marginBottom: SPACING.xl,
        textAlign: 'center',
        includeFontPadding: false,
    },
    authButtons: {
        flexDirection: 'column',
        gap: SPACING.md,
    },
    splashContactLinks: {
        marginTop: SPACING.xl,
    },
    localeToolbar: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        paddingHorizontal: SPACING.lg,
        paddingTop: SPACING.sm,
        paddingBottom: SPACING.xs,
        zIndex: 20,
        elevation: 20,
    },
    appContent: {
        flex: 1,
        padding: SPACING.xl,
        backgroundColor: COLORS.gradients.primary.start,
    },
    // Large button variants for splash screen
    btnPrimaryLarge: {
        ...ButtonStyles.btn,
        ...ButtonStyles.btnPrimary,
        paddingHorizontal: SPACING.xl * 2,
        paddingVertical: 16,
    },
    btnSecondaryLarge: {
        ...ButtonStyles.btn,
        ...ButtonStyles.btnSecondary,
        paddingHorizontal: SPACING.xl * 2,
        paddingVertical: 16,
    },
});

export default AppStyles;
